/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockMenuListCtrl
 */
angular.module('mercury.modules.stock.menu')
.controller('StockMenuListCtrl', ["$scope", "StockMenus", "title", function($scope, StockMenus, title) {
  title.set('Manage Stock Menus');

  $scope.menus = StockMenus.getAll();

  /**
  * Delete the selected menu.
  *
  * @param {Number} menu - The model of the menu to delete.
  */
  $scope.deleteMenu = function(menu, index) {
    StockMenus.remove(menu)
    .then(function() {
      $scope.menus.splice(index, 1);
    });
  };
}]);
